import { memo as Memo, useMemo } from 'react';

//* HOC's
import withLanguageContext from '@context/consumerHOC/LanguageConsumer';

//* Helpers
import GetNextDates from '@helpers/getNextDates';

//* Components
import SelectDate from './SelectDate';

const Datepicker = Memo((props) => {
	//! Getting Next Dates Object
	const days = useMemo(() => {
		return GetNextDates(props.daysCount || 7);
	}, [props.daysCount]);

	return (
		<div className={`datepicker-cont ${props.className || ''} ${props.style}`}>
			{props.style === 'select' ? (
				<SelectDate
					days={days}
					{...props}
					onChange={props.onChange}
				/>
			) : (
				'Please Select Datepicker Style'
			)}
		</div>
	);
});

export default withLanguageContext(Datepicker, ['selectedLang']);
